var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoaderVisible
    ? _c(
        "header",
        { staticClass: "container-fluid fixed-top navbar-dark bg-img" },
        [
          _c(
            "nav",
            {
              staticClass:
                "navbar navbar-expand-lg justify-content-between ui--top"
            },
            [
              _c(
                "ul",
                { staticClass: "navbar-nav" },
                _vm._l(_vm.rootMenus, function(menu) {
                  return _c(
                    "li",
                    {
                      key: menu.menuId,
                      staticClass: "nav-item dropdown",
                      attrs: { index: menu.menuId }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link dropdown-toggle",
                          attrs: {
                            href: "javascript:",
                            "data-toggle": "dropdown"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openExternalUrl(
                                menu.externalUrlUsed,
                                menu.externalUrl,
                                $event
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.getLabel(menu)) + " "
                          ),
                          _c(
                            "i",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: menu.externalUrlUsed,
                                  expression: "menu.externalUrlUsed"
                                }
                              ],
                              staticClass: "material-icons ui--menu-icon-1"
                            },
                            [_vm._v("open_in_new")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      menu.externalUrlUsed === false
                        ? _c(
                            "div",
                            {
                              staticClass: "dropdown-menu text-center-test",
                              class: {
                                "text-center":
                                  _vm.getSubmenu(menu.menuId).length >
                                  _vm.subMenuLimitCnt
                              }
                            },
                            [
                              _c(
                                "ul",
                                { staticClass: "dropdown-item" },
                                _vm._l(_vm.getSubmenu(menu.menuId), function(
                                  submenu
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: submenu.menuId,
                                      attrs: { index: submenu.menuId }
                                    },
                                    [
                                      submenu.externalUrlUsed === true
                                        ? _c("strong", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openExternalUrl(
                                                      submenu.externalUrlUsed,
                                                      submenu.externalUrl
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getLabel(submenu)
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons ui--menu-icon-2"
                                                  },
                                                  [_vm._v("open_in_new")]
                                                )
                                              ]
                                            )
                                          ])
                                        : submenu.defaultPage
                                        ? _c("strong", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.moveMenu(
                                                      submenu.defaultPage
                                                        .pagePath
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getLabel(submenu)
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons ui--menu-icon-2"
                                                  },
                                                  [_vm._v("arrow_forward_ios")]
                                                )
                                              ]
                                            )
                                          ])
                                        : _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.getLabel(submenu))
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        _vm._l(
                                          _vm.getSubmenu(submenu.menuId),
                                          function(item) {
                                            return _c(
                                              "li",
                                              {
                                                key: item.menuId,
                                                attrs: { index: item.menuId }
                                              },
                                              [
                                                item.externalUrlUsed
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openExternalUrl(
                                                              item.externalUrlUsed,
                                                              item.externalUrl
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.getLabel(item)
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons ui--menu-icon-3"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "open_in_new"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.moveMenu(
                                                              item.menuUrl
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.getLabel(item)
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "right-container" }, [
                _c("span", { staticClass: "ui--confidential float-right" }, [
                  _vm._v("Confidential")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "float-right mr-3 ui--nav-notice ui--notice-on",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.toggleNoticeArea }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("notifications")
                    ]),
                    _vm.newNoticeCount > 0
                      ? _c("span", { staticClass: "badge badge-danger" }, [
                          _vm._v(_vm._s(_vm.newNoticeCount))
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showNoticeArea,
                        expression: "showNoticeArea"
                      }
                    ],
                    staticClass: "ui--notice ui--notice-position"
                  },
                  [
                    _c("h5", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("sdl.main.message.notice")) +
                          "\n          "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.toggleNoticeArea }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("close")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui--notice-row" }, [
                      _c(
                        "div",
                        { staticClass: "ui--notice-list" },
                        _vm._l(_vm.noticeList, function(notice) {
                          return _c(
                            "a",
                            {
                              key: notice.postId,
                              class: {
                                active:
                                  _vm.selectedNotice.postId === notice.postId,
                                notread: !notice.noticeChecked
                              },
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.selectNotice(notice)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(notice.postTitle) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ui--notice-contents" }, [
                        _c("div", {
                          staticClass: "in-board",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.nl2br(
                                _vm.selectedNotice.postDetail
                              )
                            )
                          }
                        })
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f3690ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f3690ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainTopMenu.vue
// module id = null
// module chunks = 